module.exports = __webpack_public_path__ + "static/media/BrennanLodge.c8b140f7.jpeg";